import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Pack de Checklists Imprimibles',
    desc: 'Primera consulta · seguimiento · estancamiento · derivación/alertas · adherencia'
  }, {
    num: '02',
    title: 'Planilla de Seguimiento del Paciente',
    desc: 'Peso/medidas/síntomas/energía/hábito clave · para ver progreso más allá de la balanza'
  }, {
    num: '03',
    title: 'Guía de Organización del Consultorio',
    subtitle: '(Tiempo y Agenda)',
    desc: 'Cómo ordenar tu semana y tu sistema de atención para no "vivir trabajando"'
  }];
  return <section className="pt-4 pb-12 px-4 max-w-5xl mx-auto" data-id="element-14">
      <FadeIn className="text-center mb-8" data-id="element-15">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-mint text-black mb-4" data-id="element-16">
          <Gift size={32} data-id="element-17" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint mb-3" data-id="element-18">
          BONOS
        </h2>
        <p className="text-xl font-medium text-mint/70" data-id="element-19">
          (Incluidos — sin costo extra)
        </p>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-20">
        {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-surface border-2 border-dashed border-mint/30 rounded-2xl p-6 relative overflow-hidden group hover:border-mint/60 transition-colors" data-id="element-21">
            <div className="absolute -right-4 -top-4 w-24 h-24 bg-mint/10 rounded-full group-hover:bg-mint/20 transition-colors" data-id="element-22" />
            <div className="relative z-10" data-id="element-23">
              <div className="flex items-center gap-3 mb-4" data-id="element-24">
                <span className="text-3xl" data-id="element-25">🎁</span>
                <span className="font-display font-bold text-2xl text-mint" data-id="element-26">
                  BONO {bonus.num}
                </span>
              </div>
              <h3 className="font-bold text-xl text-mint mb-1" data-id="element-27">
                {bonus.title}
              </h3>
              {bonus.subtitle && <p className="font-medium text-mint/70 mb-3" data-id="element-28">
                  {bonus.subtitle}
                </p>}
              <p className="text-white/70 mt-3" data-id="element-29">{bonus.desc}</p>
              <div className="flex items-center gap-2 mt-4" data-id="element-30">
                <span className="text-white/40 line-through text-sm" data-id="element-31">
                  $9.000
                </span>
                <span className="text-mint font-[900] text-lg font-['Open_Sans',_sans-serif] uppercase" data-id="element-32">
                  Gratis
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}